import { render, staticRenderFns } from "./PatientPage.vue?vue&type=template&id=5a28b8b0&"
import script from "./PatientPage.vue?vue&type=script&lang=js&"
export * from "./PatientPage.vue?vue&type=script&lang=js&"
import style0 from "./PatientPage.vue?vue&type=style&index=0&id=5a28b8b0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports